import Game from "./Game";
import { char, chars, num } from "./serialization";

interface Engine {
  matrixData(this: Game) : Record<string, string>,
  handleMatrixDataChange(this: Game, coord : string, value : char) : boolean;

  solutionData(this: Game) : Record<num,char>;
  handleSolutionDataChange(this: Game, num: string, letter: char) : boolean;

  progressData(this: Game) : Record<string, boolean>;
}

export const EditEngine : Engine = {
  matrixData(this: Game) : Record<string, string> {
    return this.state.matrixData;
  },

  handleMatrixDataChange(this: Game, coord : string, value : char) : boolean {
    this.setState((state) => {
      let md = {...state.matrixData};

      if (value === "") {
        delete md[coord];
      } else {
        md[coord] = value;
      }

      return {matrixData: {...md}}
    });

    this.pushState();
    return true;
  },

  solutionData(this: Game) : Record<num, char> {
    return this.numberToLetter;
  },

  handleSolutionDataChange(this: Game, num: string, letter: char) : boolean {
    return false;
  },

  progressData(this: Game) : Record<string, boolean> {
    const hasOcurred = Object.keys(this.letterToNumber);
    return Object.fromEntries(chars.map(c => [c, hasOcurred.includes(c)]));
  },
}

export const PlayEngine : Engine = {
  matrixData(this: Game) : Record<string,string> {
    const l2n = this.letterToNumber;
    return Object.fromEntries(
      Object.entries(this.state.matrixData).map(([num, letter]) => [
        num,
        this.state.solutionData[l2n[letter]]||l2n[letter]||""
      ])
    );
  },

  handleMatrixDataChange(this: Game, coord : string, letter : char) : boolean {
    const mdValue = this.state.matrixData[coord];
    if (!mdValue) return letter === "";

    const l2n = this.letterToNumber;
    const num = l2n[mdValue];

    // already set?
    if (letter === this.state.solutionData[num]) return true;

    // letter already has number?
    if (letter !== "" && Object.values(this.state.solutionData).includes(letter)) return false;

    this.setState((state) => {
      return {solutionData: {...state.solutionData, [num]: letter}};
    });

    this.pushState();
    return true;
  },

  solutionData(this: Game) : Record<num, char> {
    return this.state.solutionData;
  },

  handleSolutionDataChange(this: Game, num: string, letter: char) : boolean {
    // already set?
    if (letter === this.state.solutionData[num]) return true;

    // letter already has number?
    if (letter !== "" && Object.values(this.state.solutionData).includes(letter)) return false;

    this.setState((state) => {
      return {solutionData: {...state.solutionData, [num]: letter}};
    });

    this.pushState();
    return true;
  },

  progressData(this: Game) : Record<string, boolean> {
    const hasSolution = Object.values(this.state.solutionData);
    return Object.fromEntries(chars.map(c => [c, hasSolution.includes(c)]));
  },
}


export default Engine;